/* eslint-disable react/prop-types */
import React from 'react';
import { Navigate } from 'react-router-dom';

export const PublicRoute = ({ children }) => {
  // const { logueado } = useSelector((state) => state?.usuarioCL);
  const logueado = false;
  return !logueado ? children : <Navigate to="/" />;
};
